import { render, staticRenderFns } from "./Pedido.vue?vue&type=template&id=6491e37c&scoped=true"
import script from "./Pedido.vue?vue&type=script&lang=js"
export * from "./Pedido.vue?vue&type=script&lang=js"
import style0 from "./Pedido.vue?vue&type=style&index=0&id=6491e37c&prod&lang=sass&scoped=true"
import style1 from "./Pedido.vue?vue&type=style&index=1&id=6491e37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6491e37c",
  null
  
)

export default component.exports